import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@core/server/loading.service';
import { delay, finalize } from 'rxjs';

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingSvc: LoadingService = inject(LoadingService);

  // Excluir ciertas URLs del loading si es necesario
  const excludedUrls = ['/refresh', '/logout'];
  const shouldShowLoading = !excludedUrls.some((url) => req.url.includes(url));

  if (shouldShowLoading) {
    loadingSvc.show();
  }

  return next(req).pipe(
    delay(300),
    finalize(() => {
      if (shouldShowLoading) {
        loadingSvc.hide();
      }
    })
  );
};
